/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectItemSampleCommand } from '../../models/approve-project-item-sample-command';
import { ApproveProjectItemSampleCommandResult } from '../../models/approve-project-item-sample-command-result';

export interface ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Params {
  
    /**
     * The command to approve or reject a project item Sample.
     */
    body?: ApproveProjectItemSampleCommand
}

export function apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemSampleCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectItemSampleCommandResult>;
    })
  );
}

apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain.PATH = '/api/ProjectItemSamples/ConsultantApproveOrRejectProjectItemSample';
